import React from 'react';
import ErrorImg from '../../assets/images/error.png';

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        //localStorage.clear();
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        // console.log(error, info)
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <React.Fragment>
                <div className="container">
                    <div id="notfound">
                        <div className="notfound">
                            <div className="notfound-404">
                                <img src={ErrorImg} className="img-responsive center-block" width="200px" height="auto" alt='IMG' />
                            </div>
                            <h2>Something went wrong !!</h2>
                            <p>Please contact FinX Core Support ...</p>
                            <button type="button" className="btn-1 mt-30">
                                <a href="/">Go To Homepage</a></button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
